
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"レイヤー_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M6.8 27.8H1c-.6 0-1-.4-1-1V9c0-.6.4-1 1-1h7.4l1.5-4.1c.1-.4.5-.7.9-.7H21c.4 0 .8.3.9.7L23.6 8H31c.6 0 1 .4 1 1v17.9c0 .6-.4 1-1 1h-5.8c-.6 0-1-.4-1-1s.4-1 1-1H30V10h-7.1c-.4 0-.8-.3-.9-.7l-1.5-4.1h-8.9l-1.5 4.1c-.2.4-.5.7-1 .7H2v15.9h4.8c.6 0 1 .4 1 1s-.4.9-1 .9z","id":"パス_372"}}),_c('path',{staticClass:"st0",attrs:{"d":"M16 24.2c-2.9 0-5.2-2.3-5.2-5.2 0-2.9 2.3-5.2 5.2-5.2.9 0 1.7.2 2.5.6-.7.2-1.1.8-1.1 1.5 0 .9.7 1.6 1.6 1.6.7 0 1.3-.4 1.5-1.1.4.8.6 1.6.6 2.5.1 3-2.2 5.3-5.1 5.3z","id":"前面オブジェクトで型抜き_3"}}),_c('path',{staticClass:"st0",attrs:{"d":"M-12722 3330.3c-1.8 0-3.5.7-4.8 2s-2 3-2 4.8c0 1.8.7 3.5 2 4.8s3 2 4.8 2 3.5-.7 4.8-2 2-3 2-4.8c0-1.8-.7-3.5-2-4.8s-3-2-4.8-2m0-2.1c4.9 0 8.8 3.9 8.8 8.8s-3.9 8.8-8.8 8.8-8.8-3.9-8.8-8.8 3.9-8.8 8.8-8.8z","transform":"translate(12738 -3318)","id":"パス_373"}}),_c('path',{staticClass:"st0",attrs:{"d":"M27.9 13h-1.2c-.6 0-1-.4-1-1s.4-1 1-1h1.2c.6 0 1 .4 1 1s-.4 1-1 1z","id":"パス_374"}})])
          )
        }
      }
    